var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSgyCasing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-.691,1l12.691,23.075L24.691,1H-.691Zm22,2l-2.036,3.701c-.357-1.444-1.132-2.722-2.191-3.701h4.227Zm-14.809,5.5c0-3.032,2.467-5.5,5.5-5.5s5.5,2.468,5.5,5.5-2.467,5.5-5.5,5.5-5.5-2.468-5.5-5.5Zm.418-5.5c-1.059.979-1.833,2.257-2.191,3.701l-2.036-3.701h4.227Zm2.708,12.609c.747.25,1.544.391,2.374.391s1.627-.141,2.374-.391l-2.374,4.316-2.374-4.316Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSgyCasing);
export default __webpack_public_path__ + "static/media/icon-sgy-casing.a56afa40eb23732360c4b672b4d800dc.svg";
export { ForwardRef as ReactComponent };